import Http from 'common/services/Http';
import { BudgetComponentDto } from 'api/budgets/models/BudgetComponentDto';
import IdVersion from 'api/common/types/IdVersion';
import { Paged } from 'api/common/types/Page';

export interface BudgetComponentsSearchCriteria {
    page?: number;
    itemsPerPage?: number;
    orderColumn?: string;
    orderBy?: string;
    description?: string;
    familyId?: string;
    subFamilyId?: string;
    updatedDateStart?: Date;
    updatedDateEnd?: Date;
    userUpdatedName?: string;
}

export interface BudgetComponentCatalogItem {
    id: string;
    description: string;
    familyName?: string;
    subFamilyName?: string;
}

export interface SaveComponentFromBudgetModel {
    budgetId: string;
    lineKey: string;
    description: string;
    familyId?: string | null;
    subFamilyId?: string | null;
    decimalPlaces: number;
}

class BudgetComponentsService {
    public getList(criteria: BudgetComponentsSearchCriteria) {
        return Http.get<Paged<BudgetComponentDto>>('budgetComponents', criteria);
    }

    public getById(id: string, useCurrentPrices: boolean = false) {
        return Http.get<BudgetComponentDto>('budgetComponents/' + id, { useCurrentPrices });
    }

    public create(model: BudgetComponentDto): Promise<string> {
        return Http.post('budgetComponents', model);
    }

    public update(model: BudgetComponentDto) {
        return Http.put('budgetComponents', model);
    }

    public remove(model: IdVersion) {
        return Http.put('budgetComponents/deactivate', model);
    }

    public getCatalog() {
        return Http.get<BudgetComponentCatalogItem[]>('budgetComponents/catalog');
    }

    public saveFromBudget(model: SaveComponentFromBudgetModel): Promise<string> {
        return Http.post('budgetComponents/save-from-budget', model);
    }
}

export default new BudgetComponentsService();
